import { Link } from "react-router-dom";
import { Button, Typography, useMediaQuery, useTheme } from "@mui/material";
import NotificationSubscribeInput from "../NotificationSubscribeInput";

export default function Home() {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-between",
        alignItems: "center",
        marginTop: "0.1rem",
      }}
    >
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <img
          src={
            isMobile ? "img/homepage_img_mobile.JPG" : "img/homepage_img.JPG"
          }
          alt="Adam & Tori's proposal"
          style={{ width: "100%" }}
        />
        <Typography
          variant="h6"
          sx={{
            textDecoration: "none",
            color: "inherit",
            fontFamily: "'Pinyon Script', cursive",
            fontSize: "4rem",
            marginTop: "2rem",
          }}
        >
          Adam Baker
        </Typography>
        <Typography
          sx={{
            textDecoration: "none",
            color: "inherit",
            fontSize: "1rem",
          }}
        >
          and
        </Typography>
        <Typography
          variant="h6"
          sx={{
            textDecoration: "none",
            color: "inherit",
            fontFamily: "'Pinyon Script', cursive",
            fontSize: "4rem",
          }}
        >
          Tori McLean
        </Typography>
      </div>
      <div
        style={{
          margin: "2rem",
          fontFamily: "'Great Vibes', cursive",
          fontSize: "2rem",
        }}
      >
        October 11, 2026
      </div>
      <div
        style={{
          margin: "2rem",
          marginBottom: "1rem",
          fontSize: "1.3rem",
        }}
      >
        The Gates on Roblin
      </div>
      <div
        style={{
          margin: "2rem",
          fontSize: "1.3rem",
        }}
      >
        Headingly, MB
      </div>
      <NotificationSubscribeInput />
      <Button
        component={Link}
        to="/rsvp"
        variant="outlined"
        sx={{
          margin: "2rem",
          fontSize: "1.5rem",
          padding: "0 2rem",
          backgroundColor: "rgb(80, 97, 117)",
          color: "rgb(255, 255, 237)",
          "&:hover": {
            backgroundColor: "rgb(64, 80, 97)", // slightly darker for hover
          },
        }}
      >
        RSVP
      </Button>
    </div>
  );
}
